import { generateUrlByQuery } from "@stadium/helpers/dom";

import { SETTINGS_TAB_KEYS } from "@components/recognition-program/settings/constants";
// eslint-disable-next-line no-duplicate-imports
import type { TYPE_SETTINGS_TABS } from "@components/recognition-program/settings/constants";
import {
  FEED_INDEX_ROUTE,
  FEED_TAB_ROUTE,
  FEED_POST_NEW,
  FEED_POST_ROUTE,
  FEED_USERS_LIST_ROUTE,
  RECOGNITION_PROGRAM_SETTINGS_TAB,
} from "@constants/routes";

export const getFeedPageRoute = ({
  number = "",
  tab = "",
}: {
  number: string;
  tab?: string;
}): string => {
  if (tab) {
    return generateUrlByQuery({ pathname: FEED_TAB_ROUTE, query: { number, tab } });
  }
  return generateUrlByQuery({ pathname: FEED_INDEX_ROUTE, query: { number } });
};

export const getFeedUsersRoute = ({
  programId,
  canManage,
}: {
  programId: string;
  canManage: boolean;
}) => {
  if (canManage) {
    return generateUrlByQuery({
      pathname: RECOGNITION_PROGRAM_SETTINGS_TAB,
      query: { number: programId, tab: SETTINGS_TAB_KEYS.users },
    });
  }
  return generateUrlByQuery({
    pathname: FEED_USERS_LIST_ROUTE,
    query: { number: programId },
  });
};

export const getNewFeedPostRouteMobile = ({ number = "" }) =>
  generateUrlByQuery({ pathname: FEED_POST_NEW, query: { number } });

export const getFeedPostRoute = ({
  number,
  postId,
  workspaceSlug,
}: {
  number: string;
  postId: string;
  workspaceSlug?: string;
}) =>
  generateUrlByQuery({
    pathname: workspaceSlug ? `/[workspaceSlug]${FEED_POST_ROUTE}` : FEED_POST_ROUTE,
    query: {
      number: number,
      postId: postId,
      ...(workspaceSlug ? { workspaceSlug } : {}),
    },
  });

export const getProgramFeedRoute = (number: string) =>
  generateUrlByQuery({
    query: {
      number,
    },
    pathname: FEED_INDEX_ROUTE,
  });

export const getProgramSettingsRoute = (number: string) =>
  getProgramSettingTabRoute(number, SETTINGS_TAB_KEYS.general);

export const getProgramSettingTabRoute = (
  number: string,
  tab: TYPE_SETTINGS_TABS,
  query: any = {},
  workspaceRouteUpdate = false,
) =>
  generateUrlByQuery({
    query: {
      tab,
      number,
      ...query,
    },
    pathname: workspaceRouteUpdate
      ? `/[workspaceSlug]${RECOGNITION_PROGRAM_SETTINGS_TAB}`
      : RECOGNITION_PROGRAM_SETTINGS_TAB,
  });

export const getShopSendItemsRoute = (url: string) => (url ? `${url}?send-items=true` : "");

export const getWorkspaceAwareRoute = ({
  workspaceSlug,
  route,
}: {
  workspaceSlug?: string;
  route: string;
}) => {
  const normalizedRoute = route.startsWith("/") ? route : `/${route}`;
  const firstSegment = normalizedRoute.split("/").find(Boolean);

  if (!workspaceSlug || firstSegment === workspaceSlug) return route;
  return `/${workspaceSlug}${normalizedRoute}`;
};
